

import { Injectable } from '@angular/core';
import { HttpClient, } from '@angular/common/http';
import { LanguageModel } from 'src/app/models/LanguageModel';
import { BehaviorSubject } from 'rxjs';
import { CurrencyModel } from '../models/CurrencyModel';
import { ApiControllerActionEnum } from '../models/enums/ApiControllerActionEnum';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResourceService {
  private _selectedLanguage = new BehaviorSubject<LanguageModel>(null);
  readonly selectedLanguage = this._selectedLanguage.asObservable();

  private _supportedLanguages = new BehaviorSubject<LanguageModel[]>(null);
  readonly supportedLanguages = this._supportedLanguages.asObservable();


  private _supportedCurrencies = new BehaviorSubject<CurrencyModel[]>(null);
  readonly supportedCurrencies = this._supportedCurrencies.asObservable();

  private _selectedCurrency = new BehaviorSubject<CurrencyModel>(null);
  readonly selectedCurrency = this._selectedCurrency.asObservable();

  private _styleDirection = new BehaviorSubject<string>(null);
  readonly styleDirection = this._styleDirection.asObservable();

  private _isExportableComponent = new BehaviorSubject<boolean>(false);
  readonly isExportableComponent = this._isExportableComponent.asObservable();


  private _paymentFlag = new BehaviorSubject<boolean>(false);
  readonly paymentFlag = this._paymentFlag.asObservable();

  private dataStore: { styleDirection: string, supportedCurrencies: CurrencyModel[], selectedCurrency: CurrencyModel, selectedLanguage: LanguageModel, supportedLanguages: LanguageModel[] ,isExportableComponent:boolean,paymentFlag:boolean} = { styleDirection: null, supportedCurrencies: null, selectedCurrency: null, selectedLanguage: null, supportedLanguages: null,isExportableComponent:false,paymentFlag:null };

  constructor(private http: HttpClient) { }

  updateSelectedLanguage(selectedLang) {


    environment['selectedLang'] = selectedLang.isoCode2;
    this.dataStore.selectedLanguage = selectedLang;
    this._selectedLanguage.next(Object.assign({}, this.dataStore).selectedLanguage);
  }

  updateٍSupportedLanguages(list) {

    this.dataStore.supportedLanguages = list;
    this._supportedLanguages.next(Object.assign({}, this.dataStore).supportedLanguages);
  }


  getLanguages() {

    return this.http.get<Array<LanguageModel>>(ApiControllerActionEnum.GetLanguages);
  }

  cachedSelectedLanguage(LangModel: LanguageModel) {
    localStorage.setItem('lang', JSON.stringify(LangModel));
  }

  getCachedSelectedLanguage(): LanguageModel {
    return JSON.parse(localStorage.getItem('lang'));
  }

  loadLanguages() {

    return new Promise((resolve, reject) => {

      this.http.get<Array<LanguageModel>>(ApiControllerActionEnum.GetLanguages).subscribe(res => {

        this.updateٍSupportedLanguages(res);
        let _cahchedSelectedLanguage = this.getCachedSelectedLanguage();
        if (_cahchedSelectedLanguage != null && res.filter(o => o.isoCode2 == _cahchedSelectedLanguage.isoCode2).length > 0) {
          let lang = res.filter(o => o.isoCode2 == _cahchedSelectedLanguage.isoCode2)[0];
          this.updateSelectedLanguage(lang);
          this.updateStyleDirection(lang);
        }
        else {
          this.updateSelectedLanguage(res[0]);
          this.updateStyleDirection(res[0]);
        }

        this.loadCurrencies().subscribe(currency => {

          this.updateٍSupportedCurrencies(currency);
          let _cahchedSelectedCurrency = this.getCachedSelectedCurrency();
          if (_cahchedSelectedCurrency != null && currency.filter(o => o.currencyID == _cahchedSelectedCurrency.currencyID).length > 0) {
            let _currency = currency.filter(o => o.currencyID == _cahchedSelectedCurrency.currencyID)[0];
            this.updateٍSelectedCurrency(_currency);
          }
          else {
            this.updateٍSelectedCurrency(currency[0]);
          }

          resolve(true);
        });
        //resolve(true);
      })
    })
  }


  //#region Currencies
  updateٍSupportedCurrencies(list) {

    this.dataStore.supportedCurrencies = list;
    this._supportedCurrencies.next(Object.assign({}, this.dataStore).supportedCurrencies);
  }

  updateٍSelectedCurrency(model) {

    this.dataStore.selectedCurrency = model;
    this._selectedCurrency.next(Object.assign({}, this.dataStore).selectedCurrency);
  }
  cachedSelectedCurrency(currency: CurrencyModel) {
    localStorage.setItem('currency', JSON.stringify(currency));
  }
  getCachedSelectedCurrency(): CurrencyModel {
    return JSON.parse(localStorage.getItem('currency'));
  }
  loadCurrencies() {
    return this.http.get<Array<CurrencyModel>>(ApiControllerActionEnum.GetCurrencies + `?lang=${this.dataStore.selectedLanguage.isoCode2}`)
  }
  //#endregion

  //#region  Style Direction

  updateStyleDirection(lang: LanguageModel) {

    let direction = "ltr";
    if (lang.isoCode2 == "ar") {
      direction = "rtl";
    }
    this.dataStore.styleDirection = direction;
    this._styleDirection.next(Object.assign({}, this.dataStore).styleDirection);
  }
  //#endregion

  //#region  Is Exportable Componant

  updateExportableComponantFlag(status) {

    this.dataStore.isExportableComponent = status;
    this._isExportableComponent.next(Object.assign({}, this.dataStore).isExportableComponent);
  }

  //#region

  //#region Payment FLag
 updatePaymentFlag(status) {
    this.dataStore.paymentFlag = status;
    this._paymentFlag.next(Object.assign({}, this.dataStore).paymentFlag);
  }

  //#endregion
}
